Auth = require 'db/auth'
Controller = require 'controller'
Format = require 'lib/markdown/format'
PopOver = require 'views/lib/pop-over'
PluginEnablePopOver = require 'views/plugin/plugin-enable-pop-over'
View = require 'view'
Util = require 'lib/util'
t = require('views/internal/teacup-with-helpers')('board_power_ups')
getExperiment = require 'lib/experiments/simple-test'
trackUe = require 'debug/trackUe'

POWER_UPS_LEARN_MORE_URL = "https://info.trello.com/power-ups"

class PowerUpSuggestionDetails extends View

  events:
    'click .js-enable-power-up': 'enablePowerUp'

  initialize: ->
    @powerUpEnablementInProgress = false

  enablePowerUp: (e) ->
    Util.stop(e)
    board = @options.board
    if !board.canEnableAdditionalPowerUps()
      PopOver.toggle
        elem: @$(e.target)
        view: new PluginEnablePopOver({ model: board, plugin: @model })
        autoPosition: true

      return

    if board.isPluginEnabled(@model.id)
      PopOver.hide()
      return

    @powerUpEnablementInProgress = true
    @render()
    board.enablePlugin(@model.id)
      .then =>
        trackUe('card-detail', 'enables', 'Power-Up', '', '', 'enable button', @model.id)
        @powerUpEnablementInProgress = false
        PopOver.hide()

    return

  render: ->
    powerUpDetails = @model.details

    @$el.html t.render =>
      t.p =>
        t.div '.markeddown', =>
          t.raw Format.markdownAsHtml(powerUpDetails)
        t.a '.quiet', { href: POWER_UPS_LEARN_MORE_URL, target: '_blank', rel: 'noopener' }, =>
          t.format 'learn-more'
      t.p =>
        if !@powerUpEnablementInProgress
          t.button '.button.primary.js-enable-power-up', =>
            t.format 'enable-power-up'
        else
          t.button '.button.primary', =>
            t.format 'power-up-enablement-in-progress'
      t.p '.secondary-links.quiet', =>
        t.a '.js-dismiss-power-up-suggestion', { href: '#' }, =>
          t.format 'not-now'
    @

class PowerUpSuggestionsTurnedOff extends View
  render: ->
    @$el.html t.render =>
      t.p =>
        t.format 'got-it-we-wont-ask-you-again'
      t.a '.quiet', { href: Controller.getMemberAccountUrl() }, =>
        t.format 'power-up-suggestion-settings'
    @

class StopSuggestingPowerUps extends View
  render: ->
    @$el.html t.render =>
      t.p =>
        t.format 'looks-like-you-dont-want-these-suggestions-we-wont-ask-you-again'
    @

class PluginSuggestionPopOver extends View
  viewTitleKey: 'power up suggestions'

  className: 'plugin-suggestion-pop-over'

  initialize: ({ @board }) ->
    return

  events:
    'click .js-dismiss-power-up-suggestion': 'dismissPowerUpSuggestion'

  render: ->
    @renderPowerUpSuggestionDetails()
    @

  renderPowerUpSuggestionDetails: ->
    @$el.empty()
    @appendSubview @subview(PowerUpSuggestionDetails, @model, { board: @board })
    @

  renderStopSuggestingPowerUps: ->
    trackUe('card-detail', 'opens', 'Power-up suggestions disabled screen', '', '', 'not now button', @model.id)

    @$el.empty()
    @appendSubview @subview(StopSuggestingPowerUps, @model)
    @

  renderPowerUpSuggestionsTurnedOff: ->
    @$el.empty()
    @appendSubview @subview(PowerUpSuggestionsTurnedOff, @model)
    @

  dismissPowerUpSuggestion: (e) ->
    Util.stop(e)
    idPlugin = @model.id

    powerUpSuggestionsDismissed = Auth.me().getDismissedPowerUpSuggestions()
    dismissalCount = ++powerUpSuggestionsDismissed.length unless !powerUpSuggestionsDismissed?
    powerUpSuggestionsExperiment = getExperiment 'powerUpSuggestions'
    maxDismissalCount = powerUpSuggestionsExperiment.get 'maxDismissalCount'

    if dismissalCount == maxDismissalCount
      trackUe('Power-Up enable suggestion info screen', 'disables', 'all Power-Up enable suggestions', '', '', 'not now button', idPlugin)
      @renderStopSuggestingPowerUps()
    else
      trackUe('Power-Up enable suggestion info screen', 'disables', 'Power-Up suggestion', '', '', 'not now button', idPlugin)
      PopOver.hide()

    Auth.me().dismissPowerUpSuggestionFor(idPlugin)
    return

module.exports = PluginSuggestionPopOver



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-suggestion-pop-over.coffee